module.exports = __webpack_public_path__ + "img/plane.bbeebd5e.svg";